// @flow
// 3.0 fields without app review https://developers.facebook.com/docs/facebook-login/permissions/?locale=en_US#reference-default
export default [
  'id', 'first_name', 'last_name', 'middle_name',
  'name', 'name_format', 'picture', 'short_name', 'email',
];
